import { useEffect } from 'react'

const GTM_ID = 'GTM-N2V4RJCF'
const GTM_SRC = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[]
  }
}

export function useGoogleTagManager(): void {
  useEffect(() => {
    if (document.querySelector(`script[src="${GTM_SRC}"]`)) return

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })

    const script = document.createElement('script')
    script.async = true
    script.src = GTM_SRC

    const firstScript = document.getElementsByTagName('script')[0]
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript)
    } else {
      document.head.appendChild(script)
    }
  }, [])
}

export const GTM_NOSCRIPT_SRC = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`
